export default __webpack_public_path__ + "static/og-default-1718074440240f088abacef3a6359f65.jpg";